/**
 * Created by Shikha on 2022-04-28.
 */

import {SpinePlayer} from "../../core/displayObject/SpinePlayer";
import {KarenLayers, Layers} from "./KarenLayers";
import {TimelineLite} from "gsap";
import {Karen} from "../Karen";
import {KarenSoundManager} from "../sound/KarenSoundManager";
import {KarenSoundConfig} from "../sound/KarenSoundConfig";
import {KarenParsedGameData} from "../server/data/KarenParsedGameData";

export class KarenBilBoardAnimationView extends PIXI.Container {
    private _billBoardSpine: SpinePlayer;

    constructor() {
        super();
        this.init();
    }

    public playAnimation(anim: string ): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(this._billBoardSpine.play({name: anim,loop:false}));
        return tl;
    }
    public playWildAndWin(anim: string ): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(this._billBoardSpine.play({name:anim})).add(()=>{
            if(Karen.model.parsedGameData.singleWin>0){
                this._billBoardSpine.play({name:"x_up",showOnEnd:true});
                Karen.stickyXWView.playStickyBurgerWinAnimation();
                KarenSoundManager.playSoundEffect(KarenSoundConfig.X_WAYS_STICKY_WIN);
                Karen.background.incrementxWayBy1();
                Karen.xwaysMultiplierView.increaseFSxWaysSize = true;
                KarenSoundManager.playSoundEffect(KarenSoundConfig.MULTIPLIER_UP);
            }else{
                Karen.stickyXWView.playStickyBurgerNoWinAnimation();
            }
            KarenSoundManager.playSoundEffect(KarenSoundConfig.X_WAYS_STICKY_RESET);

        });
        return tl;
    }

    public fetchDuration(anim: string): number {
        return this._billBoardSpine.fetchDuration(anim);
    }

    private init(): void {
        this._billBoardSpine = new SpinePlayer("signs", true);
        this.addChild(this._billBoardSpine);
        this.position.set(190, 70);
        KarenLayers.getLayer(Layers.BILLBOARD_VIEW)?.addChild(this);
    }
}